export const getReminderActionState = (sending: boolean, sent: boolean): { disabled: boolean; textKey: string } => {
  if (sending) return { disabled: true, textKey: 'enviandoRecordatorio' };
  if (sent) return { disabled: true, textKey: 'recordatorioEnviado' };
  return { disabled: false, textKey: 'enviarRecordatorio' };
};
